import ScorecardLogs from '@/app/scorecard-logs'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => {
  return <ScorecardLogs />
}

export const Route = createFileRoute('/_auth/_withProject/scorecard-logs')({
  component: RouteComponent,
})

